import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    // pullNewH5: pullNewH5
  },
  // 定义状态
  state: {
    buttondisabled:false,//异步请求时按钮的状态控制
    isPullNewLogin:false,//拉新赚佣是否登录
    loginInfo:null,//拉新赚佣 登录返回信息
    userInfoPullNew:null,//拉新赚佣 用户信息
  },
  //组件回调设置
  mutations:{
    setButtonDisabledState(state,msg){
      state.buttondisabled=msg;
    },
    isPullNewLogin(state,msg){//拉新赚佣 是否登录
      state.isPullNewLogin=msg;
      localStorage.isPullNewLogin=msg;
    },
    setLoginInfo(state,msg){//拉新赚佣 注册登录返回信息
      state.loginInfo=msg;
      localStorage.setItem('loginInfo',msg?JSON.stringify(msg):'');
    },
    setPullNewUserInfo(state,msg){//拉新赚佣 用户信息
      state.userInfoPullNew=msg;
      localStorage.setItem('userInfoPullNew',msg?JSON.stringify(msg):'');
    },
  },
})
/**
 * H5拉新赚佣
 */
const pullNewH5={
  state: {
    isLogin:false,
    userInfo:null
  },
  mutations:{
    isLogin(state,msg){
      state.isLogin=msg;
      sessionStorage.isLogin=msg;
    },
    setUserInfo(state,msg){
      state.userInfo=msg;
      sessionStorage.setItem('userInfo',msg?JSON.stringify(msg):'');
    }
  }
}
export default store


// WEBPACK FOOTER //
// ./src/store/store.js